/**
 * @deprecated Do not use. The endpoint that this function supports will be deprecated.
 */
export const getProductInfoFromSkuId = (products, id) => {
  return products.find(product => {
    return product.productVersions.find(productVersion => {
      return productVersion.skuId === id;
    });
  }) || null;
};
export const getProductInfoFromSkuIdV2 = (products, id) => {
  return products.find(product => {
    return product.productVersions.find(productVersion => {
      return productVersion.skuId === id;
    });
  }) || null;
};

/**
 * @deprecated Do not use. The endpoint that this function supports will be deprecated.
 */
export const getProductInfoFromQuantitySkuId = (products, id) => {
  return products.find(product => {
    return product.productVersions.find(productVersion => {
      return productVersion.quantityPackDetails.find(quantityPack => {
        return quantityPack.skuId === id;
      });
    });
  }) || null;
};
export const getProductInfoFromQuantitySkuIdV2 = (products, id) => {
  return products.find(product => {
    return product.productVersions.find(productVersion => {
      return productVersion.quantityPackDetails.find(quantityPack => {
        return quantityPack.skuId === id;
      });
    });
  });
};

/**
 * @deprecated Do not use. The endpoint that this function supports will be deprecated.
 */
export const getSkuMap = products => {
  const skus = {};
  for (const product of products) {
    for (const version of product.productVersions) {
      const productVersion = Object.assign({}, version, {
        quantityPackDetails: version.quantityPackDetails.map(quantityPack => Object.assign({}, quantityPack, {
          productVersionSkuId: version.skuId
        }))
      });
      skus[productVersion.skuId] = productVersion;
      for (const quantityPack of productVersion.quantityPackDetails) {
        skus[quantityPack.skuId] = quantityPack;
      }
    }
  }
  return skus;
};
export const getSkuMapV2 = products => {
  const skus = {};
  for (const product of products) {
    for (const version of product.productVersions) {
      const productVersion = Object.assign({}, version, {
        quantityPackDetails: version.quantityPackDetails.map(quantityPack => Object.assign({}, quantityPack, {
          productVersionSkuId: version.skuId
        }))
      });
      skus[productVersion.skuId] = productVersion;
      for (const quantityPack of productVersion.quantityPackDetails) {
        skus[quantityPack.skuId] = quantityPack;
      }
    }
  }
  return skus;
};

/**
 * @deprecated productMap uses productId which will be deprecated in favor of productApiName
 * use getProductApiNameMap instead which returns a mapping of productApiName<>ProductResponse
 */
export const getProductMap = products => {
  const productMap = products.reduce((acc, product) => {
    const {
      id
    } = product;
    return Object.assign({}, acc, {
      [id]: Object.assign({}, product, {
        productVersions: product.productVersions.map(({
          skuId
        }) => skuId)
      })
    });
  }, {});
  return productMap;
};
export const getProductApiNameMap = products => {
  const productApiNameMap = products.reduce((acc, product) => {
    const {
      apiName
    } = product;
    acc[apiName] = product;
    return acc;
  }, {});
  return productApiNameMap;
};